const amplitudeUserIdHeader = 'x-tidal-amplitude-user-id';

/**
 * @param {import("@nuxt/types").Context} context
 * @return {Promise<Record<string, any>>}
 */
export default async function getApiDataByContext({ $axios, error, isDev, redirect, route, $amplitude, res }) {
    /** @type {import('axios').AxiosResponse} */
    let response;

    /** @type {Record<string, any>} */
    let data;

    if (process.server) {
        try {
            data = await res.getApiData();
        } catch (e) {
            /** @type {import('@tidal/user-models').ClientApiError | import("@nuxt/types").NuxtError} */
            const apiError = e;

            console.error(`Retrieving API data via function call failed: ${apiError.message}`);
            error(apiError);
            return {};
        }

        if (data && data.redirectUrl) {
            if (res.headersSent) {
                console.error('Redirecting after headers already set', res.getHeaders(), res.statusCode);
                return {};
            }
            redirect(data.redirectUrl);
            return {};
        }

        let amplitudeUserId = res.getHeader(amplitudeUserIdHeader);

        if (amplitudeUserId) {
            amplitudeUserId = Array.isArray(amplitudeUserId) ? amplitudeUserId[0] : amplitudeUserId;
            $amplitude.setUserId(amplitudeUserId);
        }

        return data;
    }

    try {
        response = await $axios.get(`/api${route.fullPath}`);
    } catch (e) {
        /** @type {import('axios').AxiosError<import('@tidal/user-models').ClientApiError>} */
        const apiError = e;

        if (apiError.response && apiError.response.data) {
            error({
                ...apiError.response.data,
                // @ts-ignore
                isDev,
            });
        } else {
            error(apiError);
        }
        return {};
    }

    if (response && response.data && response.data.redirectUrl) {
        redirect(response.data.redirectUrl);
        return {};
    }

    $amplitude.setUserId(response.headers[amplitudeUserIdHeader]);

    return response.data;
}
